export default __webpack_public_path__ + "static/milocare-ebd5d3f2fd5aaf695cb85a20932ea3ea.webp";